module.exports = __webpack_public_path__ + "components/gallery-photo-upload/static/icon-sort-by-c81e49b11bb3788885881a1f77b074b2.svg";